import { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";
import {
  CardInfo,
  LayoutInfo,
  LayoutType,
  getCardInfo,
  getImage,
  getLayoutEntry,
} from "../Utils/BackendInterface";
import jura_logo_cmyk from "../resources/img/jura_logo_cmyk.png";
import contactlessIcon from "../resources/img/contactless.png";

export const CardPDF = () => {
  const [card, setCard] = useState<CardInfo | undefined>(undefined);
  const [cardImgURL, setCardImgURL] = useState("");
  const [layoutInfo, setLayoutInfo] = useState<LayoutInfo | undefined>(undefined);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id") ?? "";

    if (id) {
      getCardInfo(id).then(async (cardRes) => {
        setCard(cardRes);

        const img = await getImage(id, cardRes?.pictureExtension ?? "");
        if (img) setCardImgURL(window.URL.createObjectURL(img));

        if (cardRes) {
          const _layoutInfo = await getLayoutEntry(cardRes.idLayout);
          setLayoutInfo(_layoutInfo);
          console.log("info", cardRes, _layoutInfo);
        }
      });
    } else {
      console.error("Couldn't find a card entry for id", id);
    }
  }, []);

  useEffect(() => {
    if (layoutInfo && card) {
      // create the barcode here
      if (layoutInfo?.type === LayoutType.EMPLOYEE_CARD) {
        JsBarcode("#barcode", getEvenNumberString(card?.employeeNumber ?? ""), {
          displayValue: false,
          margin: 0,
          format: "CODE128C",
        });
      }
    }
  }, [layoutInfo, card]);

  const getEvenNumberString = (num: number | string): string => {
    let out = num.toString();
    if (out.length % 2 !== 0) {
      out = `0${out}`;
    }
    return out;
  };

  return (
    <>
      {layoutInfo?.type === LayoutType.EMPLOYEE_CARD ? (
        <div
          className="juraFontSettings"
          style={{ width: "100%", height: "100%", fontFamily: "JURA Stalemate" }}
        >
          {/* Card front (page 1) */}
          <div style={{ width: "100%", height: "100%" }}>
            {/* card image */}
            <img
              src={cardImgURL}
              style={{
                width: "calc(39.7/85 * 100%)",
                height: "100%",
                position: "absolute",
                objectFit: "cover",
                margin: 0,
              }}
            />

            {/* Logo image */}
            <img
              src={jura_logo_cmyk}
              style={{
                position: "absolute",
                width: "calc(23.889 / 85 * 100%)",
                height: "calc(11.525 / 55 * 100%)",
                right: "calc(7.2 / 85 * 100%)",
                top: "calc(5.344 / 55 * 100%)",
              }}
            />

            {/* The Card user's name */}
            <div
              style={{
                position: "absolute",
                top: "calc(28 / 55 * 100% - 1mm)",
                // bottom: "calc(15.6 / 55 * 100%)",
                left: "calc(45.4 / 85 * 100%)",
                fontSize: "12pt",
                lineHeight: "14.4pt",
                color: "#9a7348",
                whiteSpace: "pre",
              }}
            >
              {`${card?.firstName}\n${card?.surname}`}
            </div>

            {/* The Card label */}
            <div
              style={{
                position: "absolute",
                bottom: "calc(11 / 55 * 100%)",
                left: "calc(45.4 / 85 * 100%)",
                fontSize: "8pt",
              }}
            >
              {layoutInfo?.label}
            </div>
          </div>

          {/* page 2, the card back */}
          <div
            style={{
              width: "100%",
              height: "100%",
              position: "relative",
            }}
          >
            {/* test box on top of address */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: "calc(5.5 / 85 * 100%)",
                width: "20%",
                height: "calc(29.143 / 55 * 100%)",
              }}
            ></div>

            {/* the address box  */}
            <div
              style={{
                position: "absolute",
                top: "calc(29.143 / 55 * 100% - 9.7pt )", // subtracted from height because the design looked too narrow
                left: "calc(5.5 / 85 * 100%)",
                textAlign: "left",
                margin: 0,
                padding: 0,
                lineHeight: "9.7pt",
                fontSize: "8pt",
                whiteSpace: "pre-line",
              }}
            >
              {layoutInfo?.address.replace(/,/g, "\n").trim()}
            </div>

            {/* the contactless image */}
            <img
              src={contactlessIcon}
              style={{
                position: "absolute",
                width: "32px",
                height: "32px",
                right: "calc(7 / 85 * 100%)",
                top: "calc(50% - 16px)",
                objectFit: "cover",
                margin: 0,
              }}
            />

            {/* label under the address box */}
            <div
              style={{
                position: "absolute",
                bottom: "calc(5.5 / 55 * 100%)",
                left: "calc(5.5 / 85 * 100%)",
                textAlign: "left",
                verticalAlign: "bottom",
                margin: 0,
                padding: 0,
                lineHeight: "7.2pt",
                fontSize: "7pt",
                whiteSpace: "pre-line",
              }}
            >
              {layoutInfo?.notice.replace(/\./g, ".\n")}
            </div>

            {/* Website bottom right */}
            <div
              style={{
                position: "absolute",
                bottom: "calc(5.5 / 55 * 100%)",
                textAlign: "right",
                right: "calc(5.5 / 85 * 100%)",
                margin: 0,
                fontSize: "8pt",
              }}
            >
              {card?.website}
            </div>

            {/* the barcode */}
            <img
              style={{
                position: "absolute",
                top: "calc(5.5 / 55 * 100%)",
                right: "calc(5.5 / 85 * 100%)",
                width: "20%",
                height: "calc(6.85 / 55 * 100%)",
              }}
              id="barcode"
            />

            {/* The employee number under the barcode */}
            <div
              style={{
                position: "absolute",
                right: "calc(5.5 / 85 * 100%)",
                top: "calc(13.35 / 55 * 100%)",
                fontSize: "8pt",
              }}
            >
              {card !== undefined && getEvenNumberString(card.employeeNumber)}
            </div>
          </div>
        </div>
      ) : layoutInfo?.type === LayoutType.BASIC_CARD ? (
        <div
          className="juraFontSettings"
          style={{ width: "100%", height: "100%", fontFamily: "JURA Stalemate" }}
        >
          {/* Card front (page 1) */}
          <div style={{ width: "100%", height: "100%" }}>
            {/* Logo image */}
            <img
              src={jura_logo_cmyk}
              style={{
                position: "absolute",
                width: "calc(30 / 85 * 100%)",
                // height: "",
                left: "calc(44/85 * 100%)",
                top: "calc(4.5/55 * 100%)",
              }}
            />

            {/* The Card user's name */}
            <div
              style={{
                position: "absolute",
                bottom: "calc(30/55 * 100%)",
                left: "calc(5/85 * 100%)",
                maxWidth: "45%",
                fontSize: "11pt",
                lineHeight: "13pt",
                color: "black", // this werid grey
                // color: "#51626F", // this werid grey
              }}
            >
              {card?.firstName} {card?.surname}
            </div>

            {/* The job position */}
            <div
              style={{
                fontFamily: "JURA Stalemate Light",
                fontWeight: "500",
                position: "absolute",
                top: "calc(26/55 * 100%)",
                left: "calc(5/85 * 100%)",
                fontSize: "7pt",
                lineHeight: "9pt",
                // color: "black", // special red
                color: "#da291c", // special red
                whiteSpace: "pre-line",
                maxWidth: "50%",
              }}
            >
              {card?.jobDescription.replace(/,/g, "\n").trim()}
            </div>

            {/* The Card user's email and telephone */}
            <div
              style={{
                fontFamily: "JURA Stalemate Light",
                fontWeight: "500",
                position: "absolute",
                bottom: "calc(5/55 * 100%)",
                left: "calc(5/85 * 100%)",
                fontSize: "7pt",
                // lineHeight: "14.4pt",
                color: "black",
                // color: "#51626F",
                whiteSpace: "pre",
                maxWidth: "40%",
              }}
            >
              {`${card?.email ?? ""}\nTelefon\t${card?.telephone}` +
                (card?.mobile ? `\nMobil\t\t${card!.mobile}` : "")}
            </div>

            {/* The Card user's company's address */}
            <div
              style={{
                position: "absolute",
                bottom: "calc(5/55 * 100%)",
                left: "calc(45/85 * 100%)", // mamually removed 2
                fontSize: "7pt",
                lineHeight: "10pt",
                color: "black",
                // color: "#51626F",
                whiteSpace: "pre-line",
                // maxWidth: "40%",
              }}
            >
              <span style={{ fontWeight: "bold" }}>{layoutInfo?.address?.split(",")[0]}</span>{" "}
              <br />
              <div style={{ fontFamily: "JURA Stalemate Light", fontWeight: "500" }}>
                {layoutInfo?.address
                  ?.substring(layoutInfo?.address?.indexOf(",") + 1)
                  .replace(/,/g, "\n")
                  .trim()}
                <br />
                {layoutInfo?.website}
              </div>
            </div>
          </div>
        </div>
      ) : layoutInfo?.type === LayoutType.DE_V3 ? (
        <div
          className="juraFontSettings"
          style={{ width: "100%", height: "100%", fontFamily: "JURA Stalemate" }}
        >
          {/* Card front (page 1) */}
          <div style={{ width: "100%", height: "100%" }}>
            {/* Logo image */}
            <img
              src={jura_logo_cmyk}
              style={{
                position: "absolute",
                width: "calc(30 / 85 * 100%)",
                // height: "",
                left: "calc(45/85 * 100%)",
                top: "calc(4.5/55 * 100%)",
              }}
            />

            {/* The Card user's name */}
            <div
              style={{
                position: "absolute",
                top: "calc(30/55 * 100%)",
                left: "calc(5/85 * 100%)",
                maxWidth: "100%",
                fontSize: "18pt",
                lineHeight: "14pt",
                color: "black",
              }}
            >
              {card?.firstName} {card?.surname}
            </div>

            {/* The job position */}
            <div
              style={{
                fontFamily: "JURA Stalemate Light",
                fontWeight: "500",
                position: "absolute",
                top: "calc(38/55 * 100%)",
                left: "calc(5/85 * 100%)",
                fontSize: "12pt",
                lineHeight: "14pt",
                color: layoutInfo?.type !== LayoutType.DE_V3 ? "#da291c" : "black",
                whiteSpace: "pre-line",
                maxWidth: "80%",
              }}
            >
              {card?.jobDescription.replace(/,/g, "\n").trim()}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
